module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7MyJXg/tc-custom/9781398427754.jpg?1692135036787",
      "alt": "This image is the cover for the book Bigger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bigger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("There once was a pony,"), _c('br'), _vm._v("He was ever so small."), _c('br'), _vm._v("He wanted to grow,"), _c('br'), _vm._v("To reach the mark that said ‘tall’."), _c('br'), _vm._v("This is the story of one little pony who wants to be as big as a thoroughbred horse. It’s not too much to ask for, is it? With the help of his farm friends, and a naughty mouse, will he finally reach up to the sky or will he learn something quite unexpected instead?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Annie Bell-Davies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Annie Bell-Davies grew up on the Welsh coast and can’t imagine living anywhere that would take her too far away from the sea. A book lover since infancy, Annie believes in the power and importance of stories and has been writing for her own and others’ enjoyment for many years. She still lives in the countryside of West Wales with her cat, Tallulah. In her spare time, she enjoys walking, baking, and making her grandchildren giggle.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0